<template>
  <div class="ioRecord">
    <!-- <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div> -->
    <div class="right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form
          action="#"
          method="get"
          class="form-inline form-float"
          @submit.prevent
        >
          <!-- <template>
            <template v-if="showList"> -->
          <div class="form-group">
            <label>集团:</label>
            <el-select filterable v-model="search.groupId" placeholder="请选择">
              <el-option
                v-for="item in groupList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for="bdate">开始时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd"
              v-model="search.beginTime"
              type="date"
            ></el-date-picker>
          </div>
          <div class="form-group">
            <label for="bdate">结束时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd"
              v-model="search.endTime"
              type="date"
            ></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
                size="small"
                @click="searchList"
                type="primary"
                :loading="loading"
              >
                查询
              </el-button>
            </span>
            <span class="download_btn">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
              >
                导出
              </button>
            </span>
          </div>
          <!-- </template> -->
          <!-- 月 -->
          <!-- <template v-else>
              <div class="form-group">
                <span class="demonstration">月:</span>
                <el-date-picker
                  v-model="value4"
                  value-format="yyyy-MM"
                  type="month"
                  placeholder="选择月"
                ></el-date-picker>
              </div>
              <div class="form-group others">
                <span class="search_btn">
                  <button
                    @click="searchListTo"
                    type="button"
                    class="btn btn-primary"
                    id="search_btn"
                  >查询</button>
                </span>
              </div>
            </template>
          </template> -->

          <!-- <span class="switchGroup">
            <el-select v-model="switchValue" placeholder>
              <el-option value="list" label="列表">
                <span class="switch">
                  <img src="@/assets/images/temp/liebiao.png" width="16px" />
                  <span class="switch-info">列表</span>
                </span>
              </el-option>
              <el-option value="chart" label="图表">
                <span class="switch">
                  <img src="@/assets/images/temp/tubiao.png" width="16px" />
                  <span class="switch-info">图表</span>
                </span>
              </el-option>
            </el-select>
          </span> -->
        </form>
      </div>
      <template>
        <!-- <div v-show="showChart" id="myChart" style="width:950px;height:450px;"></div> -->
        <div v-show="showList" class="list-right">
          <el-table
            ref="table"
            border
            :data="tableListData"
            height="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
            v-loading="loading"
          >
            <el-table-column
              show-overflow-tooltip
              label="统计时间"
              prop="date"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="应收总额"
              prop="income"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="实收总额"
              prop="real_money"
            ></el-table-column>

            <el-table-column
              show-overflow-tooltip
              label="支付宝"
              prop="alipay"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="微信"
              prop="wechat"
            ></el-table-column>

         <!--原：现金-->
              <el-table-column
                show-overflow-tooltip
                label="异常账单"
                prop="cash"
              ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="ETC"
              prop="etc"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="余额"
              prop="balance"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="追缴欠费(总额)"
              prop="arrears"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="追缴欠费(支付宝)"
              prop="arrears_alipay"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="追缴欠费(微信)"
              prop="arrears_wechat"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="追缴欠费(现金)"
              prop="arrears_cash"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="追缴欠费(余额)"
              prop="arrears_balance"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="欠费总额"
              prop="unpay"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="外地车牌欠费"
              prop="nonlocal_unpay_money"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="本地车牌欠费"
              prop="local_unpay_money"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="当日订单笔数"
              prop="crtNum"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="当日支付笔数"
              prop="payNum"
            ></el-table-column>
          </el-table>
        </div>
      </template>
    </div>
    <Page
      v-show="showList"
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    >
    </Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  getGroupDayReportList,
  getGroupDayList,
  fetchGroupList,
} from "@/api/url";
import AreaTree from "../../commons/areaTree";
import Page from "../../commons/page";
import dayjs from "dayjs";
export default {
  data() {
    return {
      moduleName: "property",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      groupList: [],
      tableListData: [],
      tableListDataTitle: [],
      switchValue: "list",
      showList: true,
      showChart: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        beginTime: dayjs().subtract(1, "month").add(1, "day").format("YYYY-MM-DD"),
        endTime: dayjs().format("YYYY-MM-DD"),
        groupId: null,
      },
      value4: "",
      pageObj: {},
      loading: false,
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    // handleTreeClick: function (node, data) {
    //   this.search.beginTime = "";
    //   this.search.endTime = "";
    //   this.value4 = "";
    //   if (node.type == "group") {
    //     this.treeData.groupId = node.id;
    //     if (this.showList) {
    //       this.search.pageNumber = 1;
    //       this.tableList(this.search.pageNumber);
    //     }
    //     if (this.showChart) {
    //       this.echarts();
    //     }
    //   } else {
    //     this.treeData.groupId = "";
    //     this.tableListData = [];
    //     var pageObj = {
    //       curIndex: 1,
    //       rowsCount: 0,
    //     };
    //     this.getPage(pageObj);
    //     //  this.$message({
    //     // 	message: '请选择车场！',
    //     // 	type: 'warning'
    //     // 	});
    //   }
    // },
    tableList: function (curPage) {
      var _this = this;
      this.loading = true;
      this.$get(getGroupDayReportList(), {
        page: curPage,
        limit: this.search.pageSize,
        groupId: this.search.groupId,
        beginTime: this.search.beginTime,
        endTime: this.search.endTime,
      })
        .then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.pageObj = { ...pageObj };
          // _this.getPage(pageObj);
          _this.tableListData = data.data.rows;
          _this.$nextTick(() => {
            _this.$refs.table.doLayout();
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 图表
    // echarts: function () {
    //   var _this = this;
    //   this.$get(getGroupDayList(), {
    //     groupId: this.treeData.groupId,
    //     beginTime: this.value4,
    //   }).then((data) => {
    //     this.myChart.series[0].data = [];
    //     this.myChart.series[1].data = [];
    //     this.myChart.series[2].data = [];
    //     this.myChart.xAxis[0].data = [];
    //     if (data.status != 200) return;
    //     for (var i in data.data.rows) {
    //       this.myChart.series[0].data.push(data.data.rows[i].real_money);
    //       this.myChart.series[1].data.push(data.data.rows[i].unpay);
    //       this.myChart.series[2].data.push(data.data.rows[i].arrears);
    //       this.myChart.xAxis[0].data.push(data.data.rows[i].date);
    //     }
    //     let myChart = this.$echarts.init(document.getElementById("myChart"));
    //     myChart.setOption(this.myChart);
    //   });
    // },
    searchList() {
      var flTime = this.timeCompare(this.search.beginTime, this.search.endTime);
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (!Boolean(this.search.beginTime)) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (!Boolean(this.search.endTime)) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }

      var compareTime = this.timeCompare(
        this.search.endTime,
        dayjs(this.search.beginTime).add(1, "month").format("YYYY-MM-DD")
      );

      if (compareTime) {
        return this.$layer.msg("请选择一个月以内的日期", { time: 1 });
      }

      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function (bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      console.log('bdate', bdate);
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate >= 0) {
        return true;
      } else {
        return false;
      }
    },
    // searchListTo: function () {
    //   if(!this.treeData.groupId){
    //      this.$message({
    //       message: "请选择集团！",
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   this.echarts();
    // },

    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    getGroupList() {
      return this.$get(fetchGroupList()).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          this.groupList = data;
        }
      });
    },
    async initGroup() {
      await this.getGroupList();
      this.search.groupId = this.groupList[0].id;
      this.tableList(this.search.pageNumber);
    },
    downloadData() {
      this.$downloadFileRequest(
        "/api/parking/parkingOrders/groupDailyStatementExport",
        {
          groupId: this.search.groupId,
          beginTime: this.search.beginTime,
          endTime: this.search.endTime,
        },
        "集团日报"
      );
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },
  components: {
    Page,
    AreaTree,
  },

  mounted: function () {
    this.initGroup();
  },
  // watch: {
  //   switchValue: function (newVal, oldVal) {
  //     if (newVal === "chart") {
  //       this.showChart = true;
  //       this.showList = false;
  //       if(this.treeData.groupId){
  //         this.echarts();
  //       }
  //     } else {
  //       this.showChart = false;
  //       this.showList = true;
  //       if(this.treeData.groupId){
  //         this.tableListData(this.curIndex)
  //       }
  //     }
  //   },
  // },
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
  width: 16px;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
  width: 16px;
}
.show-list {
  height: 500px;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
.download_btn {
  display: inline-block;
  margin-left: 15px;
}
</style>